export function getProtocol(value: string) {
  try {
    const url = new URL(value);
    return url.protocol;
  } catch {
    return null;
  }
}
